import { TeacherPage } from "@/components/teacher/TeacherPage";
import { ClassroomGrid } from "@/components/teacher/classroom/ClassroomGrid";
import { useT } from "@/i18n";
import { useNavigate } from "@tanstack/react-router";

/** Picking the class is the whole page: every card opens that class's self-study records. */
export function SelfStudyRecordPage() {
  const navigate = useNavigate();
  const t = useT();

  return (
    <TeacherPage title={t["selfStudy.title"]} subtitle={t["selfStudy.pickClassroom"]}>
      <ClassroomGrid
        onSelect={(classroomId) =>
          navigate({ to: "/teacher/self-study-record/$classroomId", params: { classroomId } })
        }
      />
    </TeacherPage>
  );
}
